import React, { useState, useEffect } from "react";
import axios from "axios";
import Header from "../../../Components/Header";
import SingleSignOnSideBar from "../../../Components/SingleSignOnSideBar";
import PartnerApplicationStatusComp from "./PartnerApplicationStatusComp";
import PartnerDocumentDetailsPreview from "./PartnerDocumentDetailsPreview";
import { PARTNER } from "../../../Configuration/Partner_URL";
import { decryptData } from "../../../CommonMethhods/CommonMethods";

function PartnerApplicationStatus() {
  const storeToken = localStorage.getItem("ssoToken");
  const [partnerDetails, setPartnerDetails] = useState([]);
  const [loader, setLoader] = useState(true);

  if (storeToken == null) {
    window.location.replace("/");
  }

  const getPartnerId = async () => {
    let id = localStorage.getItem("PartnerId")
    try {
      const getDetail = await axios.get(
        `${PARTNER.GET_PARTNER_ID}?id=${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
          },
        }
      );
      const res = decryptData(getDetail.data);
      const getRes = JSON.parse(res)
      if (typeof getRes == "object") {
        setPartnerDetails(getRes.data.partner);
      }
      setLoader(false);
    } catch (error) {
      console.log(error);
    }
    finally {
      setLoader(false);
    }
  };
  useEffect(() => {
    getPartnerId();
  }, []);

  return (
    <>
      <Header headerDetails={partnerDetails} portal={"TELECALLER"} />
      <SingleSignOnSideBar />
      <main id="main-content" >
        <PartnerApplicationStatusComp partnerDetails={partnerDetails} loader={loader} />

        <PartnerDocumentDetailsPreview partnerDetails={partnerDetails} />



      </main>
    </>
  );
}

export default PartnerApplicationStatus;
